<template>
  <div>
      <div class="card mb-5">
        <div class="card-header">
          <h2>{{review.establishment.consultant.firstname}} a traité cet avis.</h2>
        </div>
        <div class="card-body">
          <h2 style="font-weight:bold;"> Voici le contenu rédigé par MHR</h2>
        </div>
        <div class="card-body pt-0">
          <EstablishmentReviewContent :review="review" />
        </div>
        <div class="card-body">
          <h2 style="font-weight:bold;">Voici le contenu des échanges.</h2>
        </div>
        <div class="card-body pt-0">
          <EstablishmentAllMessage :review="review" :currentState="state" />
        </div>

      </div>
    </div>
</template>
 
<script>
import UPDATE_STATE_DATA from '@/gql/mutations/updateStateData.graphql';
import { gqlMutation } from '@/gqlClient.js';
import tools from "@/tools.js";
import StateComments from "@/components/StateComments.vue";
import EstablishmentReviewContent from "@/components/EstablishmentReviewContent";
import EstablishmentAllMessage from "@/components/EstablishmentAllMessage";

export default {
  name: "EstablishmentStateAnswerAccepted",
  components: {
    StateComments,
    EstablishmentAllMessage,
    EstablishmentReviewContent
  },
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      state: null
    };
  },
  methods: {
    async save_modification(comments) {
      if (comments) {
        this.state.data.comments = comments;
      }
      let serialized = JSON.stringify(this.state.data);
      serialized = tools.b64_encode(serialized);
      await gqlMutation(UPDATE_STATE_DATA, { uid: this.state.uid, serialized: serialized });
    },
    update_data(comments) {
      this.state.data.comments = comments;
      this.save_modification(comments);
    }
  },
  created() {
    const self = this;
    this.state = this.review.current_state;

    if (this.state.data) {
      if (typeof this.state.data === "string") {
        this.state.data = JSON.parse(this.state.data);
      }
    }

    // pour les mises à jour en direct
    self.$djangows["onmodelsignals"]({ modelName: "state", appLabel: "state" }, (event) => {
      if (event.obj) {
        if (event.obj.uid === self.state.uid) {
          if (event.signal_type === "post_save" && event.created === false) {
            self.state.data.comments = event.obj.data.comments;
          }
        }
      }
    });
  }
};
</script>

<style lang="scss" scoped>
</style>
